import axiosBaseApi from '../common/lib/axiosBaseApi';
import { Fingerprint } from './fingerprint.types';

export const getLastLoginData = async () => await axiosBaseApi.get<Fingerprint[]>(`/v1/fingerprint`);
